export const blockIconsHomeGasMeter = (
	<span className='material-symbols-outlined'>gas_meter</span>
);
